import { useNavigate } from "react-router-dom";
import { ArrowRight, Database } from "lucide-react";

import { Button } from "../../components/ui/button";
import { ContainerCard } from "../../components/ui/cards";
import { MASTER_BUNDLE_MIGRATION, getMigrationSampleUrl } from "./masterMigrationConfigs";

const MasterMigrationLinks = () => {
    const navigate = useNavigate();
    const href = `/datamigration/master/${MASTER_BUNDLE_MIGRATION.slug}`;
    const sampleUrl = getMigrationSampleUrl(MASTER_BUNDLE_MIGRATION.type);

    return (
        <div className="mt-4">
            <ContainerCard>
                <div className="p-4 flex flex-col sm:flex-row sm:items-center justify-between gap-4">
                    <div className="min-w-0">
                        <h3 className="text-sm font-semibold text-gray-800 dark:text-gray-100 flex items-center gap-2">
                            <Database className="w-4 h-4 text-sidebar-primary" />
                            Master Migration
                        </h3>
                        <p className="text-xs text-muted-foreground mt-1 max-w-xl">
                            Import departments, shifts, user groups, and other master records from one CSV before employee migration.
                        </p>
                        {sampleUrl && (
                            <a
                                href={sampleUrl}
                                download
                                className="inline-block mt-2 text-xs text-sidebar-primary hover:underline"
                            >
                                Download sample CSV
                            </a>
                        )}
                    </div>
                    <Button variant="outline" size="sm" onClick={() => navigate(href)} className="shrink-0">
                        Open Master Migration
                        <ArrowRight className="w-3.5 h-3.5 ml-1" />
                    </Button>
                </div>
            </ContainerCard>
        </div>
    );
};

export default MasterMigrationLinks;
